export default {
  loading: false,
  loadingEventos: false,
  loadingSuppression: false,
  email: null,
  emails: [],
  suppressions: [],
  eventos: [],
  page: 1,
  pages: 1,
  itemsPerPage: 10,
  suppressionsPage: 1,
  suppressionsPages: 1,
  suppressionsItemsPerPage: 10,
  filters: {}
};
